// Add debounce utility
let geocoderTimeout = null;
const debounce = (fn, delay) => {
  return function (...args) {
    if (geocoderTimeout) {
      clearTimeout(geocoderTimeout);
    }
    return new Promise((resolve) => {
      geocoderTimeout = setTimeout(() => {
        resolve(fn(...args));
      }, delay);
    });
  };
};

export const MAP_CONSTANTS = {
  DEFAULT_RADIUS: 50,
  MIN_RADIUS: 1,
  LONGPRESS_DURATION: 500, // milliseconds
  REVERSE_GEOCODING_AUTHORIZED_KEYS: [
    "road",
    "quarter",
    "neighbourhood",
    "suburb",
    "city",
    "municipality",
    "county",
    "state",
    "region",
    "postcode",
    "country",
    "country_code",
  ],
};

// Geocoder configuration with debouncing
const actualForwardGeocode = async (config) => {
  const features = [];
  try {
    let request =
      "https://nominatim.openstreetmap.org/search?q=" +
      config.query +
      "&format=geojson&polygon_geojson=1&addressdetails=1";
    const response = await fetch(request);
    const geojson = await response.json();
    for (let feature of geojson.features) {
      let center = [
        feature.bbox[0] + (feature.bbox[2] - feature.bbox[0]) / 2,
        feature.bbox[1] + (feature.bbox[3] - feature.bbox[1]) / 2,
      ];
      let point = {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: center,
        },
        place_name: feature.properties.display_name,
        properties: feature.properties,
        text: feature.properties.display_name,
        place_type: ["place"],
        center: center,
      };
      features.push(point);
    }
  } catch (e) {
    console.error(`Failed to forwardGeocode with error: ${e}`);
  }

  return {
    features: features,
  };
};

// Debounce with 300ms delay
const debouncedForwardGeocode = debounce(actualForwardGeocode, 300);

export const Geo = {
  forwardGeocode: async (config) => {
    // Only debounce if there is content to search
    if (config.query && config.query.length > 2) {
      return debouncedForwardGeocode(config);
    } else {
      return { features: [] };
    }
  },
};
